import { createContext } from 'react'

import { type SubMenuTriggerContextProps } from '@ui/Menu/SubMenuTrigger/SubMenuTrigger'

const SubMenuTriggerContext = createContext<SubMenuTriggerContextProps | null>(null)

export default SubMenuTriggerContext
